const premiumProxies = `{
  "premium_proxies": true
}`;

export default premiumProxies;
